const topics = [
  { label: '庆余年3', heat: '9.8万讨论', hot: true },
  { label: '墨雨云间', heat: '8.2万讨论', hot: true },
  { label: '背着善宰跑', heat: '7.5万讨论', hot: true },
  { label: '泪之女王', heat: '6.8万讨论', hot: false },
  { label: '繁花', heat: '6.1万讨论', hot: false },
  { label: '与凤行', heat: '5.4万讨论', hot: false },
  { label: '玫瑰的故事', heat: '4.9万讨论', hot: false },
  { label: '长相思2', heat: '4.3万讨论', hot: true },
  { label: '你比星光美丽', heat: '3.8万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100 px-3 py-1 rounded-full mb-3">
              社区热议
            </span>
            <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
              热门话题
            </h2>
            <p className="text-sm text-foreground-500 mt-2">看看大家都在讨论哪些剧集</p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((topic) => (
              <a
                key={topic.label}
                href="#topics"
                className="group flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-100 border border-background-200 hover:border-primary-300 hover:bg-primary-50 transition-all cursor-pointer"
              >
                {topic.hot && (
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-fire-line text-accent-500 text-sm"></i>
                  </span>
                )}
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 whitespace-nowrap">
                  {topic.label}
                </span>
                <span className="text-xs text-foreground-400">{topic.heat}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}